<template lang="pug">
payment-order-block-form 
  app-text-field( v-model="form.payerBill" label="Расчетный счет плательщика" hideDetails dense :rules="[rules.required, rules.number, rules.payerBill]"  )
  app-text-field( v-model="form.bankBik" label="БИК банка" hideDetails dense :errorText="form.bikError" @change="getPayerBank(form.bankBik)" :rules="[rules.required, rules.number, rules.bankBIK]"  )
  app-text-field( v-model="bankName" label="Наименование банка" hideDetails dense readonly )
  app-text-field( v-model="corrBill" label="Корреспондентский счет банка" hideDetails dense readonly )
</template>

<script>
import PaymentOrderBlockForm from './PaymentOrderBlockForm.vue';
import { mapActions } from 'vuex'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [ $_validate_rules ],

  components: {
    PaymentOrderBlockForm
  },

  props: {
    form: null
  },

  data() {
    return {
      bankName: '', 
      corrBill: ''
    }
  },

  methods: {
    ...mapActions('expert', ['getBankInfo']), 

    getPayerBank(bik) {
      if (bik) {
        this.getBankInfo(bik).then(data => {
          this.bankName = data?.name ?? ""
          this.corrBill = data?.account ?? ""
        })
      } else {
        this.bankName = ""
        this.corrBill = ""
      }
    }
  }
}
</script>